import React from "react";
import "../../css/tp-sect5.css";
import TPSect5IllLG from "../../assets/images/teacherPage-sect5-Ill-lg.png";
import TPSect5IllSM from "../../assets/images/teacherPage-sect5-Ill-sm.png";
import { ReactComponent as TPSect5CheckIc } from "../../assets/icons/tp/check.svg";

const Sect5 = () => {
  return (
    <section id="tp-sect5">
      <div>
        <img id="tp-s5-lg" src={TPSect5IllLG} alt="" />
        <img id="tp-s5-sm" src={TPSect5IllSM} alt="" />
        <article>
          <h2>Join 23,000+ teachers on LMS right now</h2>
          <div>
            <div>
              <span>
                <TPSect5CheckIc className="tp-sect5-check-icon" />
              </span>
              <p>Mauris pellentesque congue libero nec</p>
            </div>
            <div>
              <span>
                <TPSect5CheckIc className="tp-sect5-check-icon" />
              </span>
              <p>Suspendisse mollis tincidunt</p>
            </div>
            <div>
              <span>
                <TPSect5CheckIc className="tp-sect5-check-icon" />
              </span>
              <p>Praesent varius justo vel justo pulvinar </p>
            </div>
          </div>
          <button>Join now</button>
        </article>
      </div>
    </section>
  );
};
export default Sect5;
